import { teamsInitialState } from './initial-state';
import { TeamsActions } from './action-creators';
import { TeamsState } from './state';
import * as actions from './actions';

export const teamsReducer = (
  state: TeamsState = teamsInitialState,
  action: TeamsActions
): TeamsState => {
  switch (action.type) {
    case actions.GET_TEAM_MEMBERS_SUCCESS:
      return {
        ...state,
        teamMembers: action.members,
      };

    case actions.UPDATE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        teamMembers: state.teamMembers.map((t) =>
          t.id === action.member.id ? action.member : t
        ),
      };

    case actions.REMOVE_TEAM_MEMBER:
      return {
        ...state,
        teamMembers: state.teamMembers.filter((t) => t.id !== action.member.id),
      };

    case actions.CREATE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        teamMembers: [...state.teamMembers, action.member],
      };

    default:
      return state;
  }
};

export default teamsReducer;
